var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    transform: "matrix(1 0 0 -1 0 23)",
    stroke: "#5C6677"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0916 6.90505C16.7432 6.55725 16.1784 6.55725 15.83 6.90505L15.3829 7.35136L16.6445 8.61087L17.0916 8.16457C17.44 7.81676 17.44 7.25285 17.0916 6.90505ZM15.4799 9.7735L14.2182 8.51399L6.64706 16.0719V17.3558H7.88438L15.4799 9.7735ZM5.24121 15.1501C5.08676 15.3043 5 15.5134 5 15.7314V18.1779C5 18.6319 5.36871 19 5.82353 19H8.2255C8.44392 19 8.65339 18.9134 8.80783 18.7592L18.2563 9.32718C19.2479 8.33728 19.2479 6.73233 18.2563 5.74243C17.2647 4.75252 15.6569 4.75252 14.6653 5.74243C14.6653 5.74243 14.6653 5.74243 14.6653 5.74243L5.24121 15.1501Z",
    fill: "#5C6677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountEdit);
export default __webpack_public_path__ + "static/media/discount_edit.c44c6aade49a92e7fa234c9639897087.svg";
export { ForwardRef as ReactComponent };